import { Injectable, EventEmitter, Injector } from '@angular/core';
import { VuCommunicationService } from '../vu/vu-communication.service';
import { IVuConnection } from '../vu/connection/vu-connection.interfaces';

@Injectable()
export class BarcodeReaderService {
  private vuCommunicationService: VuCommunicationService;
  private vuConnection: IVuConnection;

  barcodeScanned: EventEmitter<string> = new EventEmitter<string>();
  barcodeScanStarted: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected injector: Injector,
  ) {
    this.vuCommunicationService = injector.get(VuCommunicationService);
    this.vuConnection = this.vuCommunicationService.vuConnection;
    this.vuConnection.eventBarcodeRead.subscribe((barcode: string) => this.onBarcodeRead(barcode));
    this.vuConnection.eventBarcodeReadStarted.subscribe(() => this.onBarcodeReadStarted());
  }

  onBarcodeRead(barcode: string): void {
    this.barcodeScanned.emit(barcode);
  }

  onBarcodeReadStarted(): void {
    this.barcodeScanStarted.emit();
  }

  barcodeLedEnable(value: boolean): void {
    if (this.vuCommunicationService.vuHttp != null) {
      this.vuCommunicationService.vuHttp.barcodeLedEnable(value);
    }
  }
}
